import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconToque: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="toque, chefs-cap, cook" maskId="round-filled-radius-0-stroke-1.5-IconToque"><path d="M17.1967 4.99927L17.1994 5.0039C19.8684 5.10856 22 7.30535 22 10C22 12.0503 20.7659 13.8124 19 14.584V16.5H5V14.584C3.2341 13.8124 2 12.0503 2 10C2 7.30541 4.13152 5.10867 6.80043 5.00391C7.8373 3.20835 9.77754 2 12 2C14.2221 2 16.1608 3.20848 17.1967 4.99927Z" fill="currentColor"/><path d="M5 18V21.25C5 21.6642 5.33579 22 5.75 22H18.25C18.6642 22 19 21.6642 19 21.25V18H5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconToque;
